import { buildAxiosWithoutInterceptors, buildMakeUseAxios } from "@root/api/api.tools";

export const axiosChallenges = buildMakeUseAxios(`${import.meta.env.VITE_CHALLENGE_SERVICE_URL}/challenges`);
export const axiosChallengesWithoutInterceptors = buildAxiosWithoutInterceptors(
  `${import.meta.env.VITE_CHALLENGE_SERVICE_URL}/challenges`
);
